import React, { useState } from 'react';
import { Activity, HeadphonesIcon, BarChart3, UserCheck } from 'lucide-react';
import VitalsDashboard from './VitalsDashboard';
import SupportHub from './SupportHub';
import ImpersonationPanel from './ImpersonationPanel';
import ClientKPIDashboard from './ClientKPIDashboard';

const TABS = [
  { id: 'vitals', label: 'Vitals', icon: Activity },
  { id: 'support', label: 'Support Hub', icon: HeadphonesIcon },
  { id: 'kpis', label: 'Client KPIs', icon: BarChart3 },
  { id: 'impersonation', label: 'Impersonation', icon: UserCheck },
];

const SuperAdminDashboard = ({ onImpersonate }) => {
  const [activeTab, setActiveTab] = useState('vitals');
  const isMobile = window.innerWidth < 768;

  return (
    <div className="flex-1 flex flex-col h-full overflow-auto">
      {/* Header */}
      <div className="px-6 py-4 border-b" style={{ backgroundColor: '#071D39', borderColor: '#89A8B1' }}>
        <h1 className="text-xl font-bold text-white">SuperAdmin Dashboard</h1>
        <p className="text-sm" style={{ color: '#89A8B1' }}>Platform management & monitoring</p>
      </div>

      {/* Tab Navigation — hidden on mobile */}
      {!isMobile && (
        <div className="flex border-b" style={{ borderColor: '#89A8B1' }}>
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className="flex items-center gap-2 px-6 py-3 text-sm font-semibold transition-colors"
                style={{
                  borderBottom: isActive ? '3px solid #75BB2E' : '3px solid transparent',
                  color: isActive ? '#071D39' : '#516469',
                  backgroundColor: isActive ? '#F0F4F5' : 'transparent',
                }}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      )}

      {/* Tab Content */}
      <div className="flex-1 overflow-auto p-6" style={{ backgroundColor: '#F5F7F8' }}>
        {activeTab === 'vitals' && <VitalsDashboard />}
        {activeTab === 'support' && <SupportHub />}
        {activeTab === 'kpis' && <ClientKPIDashboard />}
        {activeTab === 'impersonation' && <ImpersonationPanel onImpersonate={onImpersonate} />}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;